export const PLANNING_WIZARD_NAMESPACE = 'planningWizard'
